class CustomComparisonTable {
  constructor(section) {
    this.section = section;
    this.tableWrap = section.querySelector('[data-table-wrap]');

    if (!this.tableWrap) return;

    this.updateScrollState = this.updateScrollState.bind(this);
    this.onResize = this.onResize.bind(this);

    this.init();
  }

  init() {
    this.updateScrollState();

    this.tableWrap.addEventListener('scroll', this.updateScrollState, { passive: true });
    window.addEventListener('resize', this.onResize);

    document.addEventListener('shopify:section:load', this.onResize);
    document.addEventListener('shopify:section:reorder', this.onResize);
    document.addEventListener('shopify:block:select', this.onResize);
  }

  onResize() {
    window.requestAnimationFrame(() => {
      this.updateScrollState();
    });
  }

  updateScrollState() {
    const maxScrollLeft = this.tableWrap.scrollWidth - this.tableWrap.clientWidth;
    const scrollLeft = this.tableWrap.scrollLeft;

    if (maxScrollLeft > 4 && scrollLeft > 4) {
      this.tableWrap.classList.add('is-scrollable-left');
    } else {
      this.tableWrap.classList.remove('is-scrollable-left');
    }

    if (maxScrollLeft > 4 && scrollLeft < maxScrollLeft - 4) {
      this.tableWrap.classList.add('is-scrollable-right');
    } else {
      this.tableWrap.classList.remove('is-scrollable-right');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.custom-comparison-table');

  sections.forEach((section) => {
    new CustomComparisonTable(section);
  });
});
